module.exports = __webpack_public_path__ + "static/media/research_zumkha_logo.f32fac00.png";